var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.462,
    height: 19.856,
    viewBox: "0 0 32.462 19.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M409.259,362.789a9.928,9.928,0,1,1,9.928-9.928A9.939,9.939,0,0,1,409.259,362.789Zm0-18.245a8.318,8.318,0,1,0,8.318,8.317A8.327,8.327,0,0,0,409.259,344.543Z",
    transform: "translate(-399.331 -342.933)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.606)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M425.993,362.789a9.928,9.928,0,1,1,9.928-9.928A9.939,9.939,0,0,1,425.993,362.789Zm0-18.245a8.318,8.318,0,1,0,8.318,8.317A8.327,8.327,0,0,0,425.993,344.543Z",
    transform: "translate(-416.065 -342.933)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.ff0a07ba0a25d769f703de67f64aeb8c.svg";
export { ForwardRef as ReactComponent };